import moment from 'moment';
import { concat, interval, Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";

/**
 *  This method clean date from Timezone
 *  and can return null, if a null date is passed.
 */
export const cleanDateFromTimezone = (date: Date | string): string | null => {
  return date ? moment(date).utcOffset(0, true).format() : null;
}

/**
 * Datetime has an offset (typically 1 second ahead) to work smoothly with p-date-picker maxDate validation,
 * see comments in https://mynexusdevelopment.visualstudio.com/Portal%203.0/_git/myNexus.Web/pullrequest/16750
 */
export function trackDateTime(offset = 1000): Observable<Date> {
  const currentDate = new Date(Date.now() + offset);

  // Workaround to start tracking immediately rather than after 1 sec ("startWith" does not work with "interval")
  return concat(
    of(currentDate),
    interval(1000).pipe(
      tap(() => {
        currentDate.setSeconds(currentDate.getSeconds() + 1);
      }),
      map(() => currentDate)
    )
  );
}
